const Adopt = () => {
    return (
        <div>
            <h1>Adopt</h1>
        </div>
    )
}

export default Adopt;